module.exports = __webpack_public_path__ + "static/media/poleDance.70b8f33c.svg";